import React, { useMemo, useReducer } from 'react';
import { authReducer } from './authReducer';
import { AuthContext } from './useAuth';

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = (props: AuthProviderProps) => {
  const [state, dispatch] = useReducer(authReducer, 'INITIALIZING');
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <AuthContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
